import { LN_PORTAL_URL } from '@lno/core/constants'

export const URLS = {
  regulamentoAuxilioDivida: `${LN_PORTAL_URL}/limpa-nome-online/feirao/regulamento-auxilio-divida/`,
  megaFeirao: `${LN_PORTAL_URL}/limpa-nome-online/feirao/`,
  desenrola: `${LN_PORTAL_URL}/limpa-nome-online/desenrola-brasil/`,
  agenciaCorreios: `${LN_PORTAL_URL}/limpa-nome-online/correios/`,
  desenrolaOffersWeb: `${LN_PORTAL_URL}/area-cliente/solucoes/negociar?utm_source=site-deslogado-serasa&utm_medium=site&utm_campaign=desenrola-brasil-serasa-lno`,
  desenrolaAppInstall: `https://app.adjust.com/18x8fgln?adgroup=desenrola-brasil-serasa-lno&fallback=https%3A%2F%2Fwww.serasa.com.br%2Farea-cliente%2Fsolucoes%2Fnegociar%3Futm_source%3Dsite-deslogado-serasa%26utm_medium%3Dsite%26utm_campaign%3Ddesenrola-brasil-serasa-lno`,
}
